@let chips = getChips();
<section class="inner-filter" [class.hide]="!chips?.length">
  <span class="filter-results">
    <p>{{ 'app.general.results' | translate }}:</p>
    <p class="bold">{{ innerFiltersRowCount() }}</p>
  </span>
  <mat-divider vertical class="filter-divider" />
  <p>{{ 'app.general.filterBy' | translate }}:</p>
  <div class="filter-visible-part">
    <div class="filter-container">
      @for(chip of chips; track $index) {
        <mat-chip-row
          class="chip"
          disableRipple
          [appTooltip]="chip.tooltip | translate"
          [position]="position.BELOW"
          (removed)="remove(chip.columnName, chip.value)"
        >
          <span>{{ chip.translatedValue ? (chip.translatedValue | translate) : chip.value }}</span>
          <button class="chip-button" type="button" matChipRemove [attr.aria-label]="'remove ' + chip.value">
            <mat-icon svgIcon="icon-close" class="chip-button-icon" />
          </button>
        </mat-chip-row>
      }
    </div>
  </div>
  @if (innerFilters()?.length) {
    <button type="button" class="reset" (click)="removeAll()">{{ 'app.general.reset' | translate }}</button>
  }
</section>
